import { useEffect, useState } from 'react'
import {
  useBackgroundJobStore,
  useHasOngoingBackgroundJobs,
} from './useBackgroundJobStore'

export const useBackgroundJobCleanup = () => {
  const { backgroundJobs, removeBackgroundJobs } = useBackgroundJobStore()
  const [hasInteracted, setHasInteracted] = useState(false)

  const hasOngoingJobs = useHasOngoingBackgroundJobs()

  const shouldAttachEventListeners =
    !hasInteracted && !hasOngoingJobs && Object.keys(backgroundJobs).length > 0

  useEffect(() => {
    if (!hasInteracted) {
      return
    }

    const expiredJobs = Object.values(backgroundJobs)
      .filter(job => job.status !== 'IN_PROGRESS')
      .map(job => job.id)

    if (expiredJobs.length === 0) {
      return
    }

    const timeoutId = setTimeout(() => {
      setHasInteracted(false)

      removeBackgroundJobs(expiredJobs)
    }, 20_000)

    return () => {
      clearTimeout(timeoutId)
    }
  }, [hasInteracted, backgroundJobs, removeBackgroundJobs])

  useEffect(() => {
    const handleUserInteraction = () => setHasInteracted(true)
    if (shouldAttachEventListeners) {
      // Attach event listeners
      window.addEventListener('mousemove', handleUserInteraction)
      window.addEventListener('keydown', handleUserInteraction)
      window.addEventListener('click', handleUserInteraction)
    }

    return () => {
      // Clean up listeners and timeout
      window.removeEventListener('mousemove', handleUserInteraction)
      window.removeEventListener('keydown', handleUserInteraction)
      window.removeEventListener('click', handleUserInteraction)
    }
  }, [shouldAttachEventListeners, setHasInteracted])
}
